import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=6ed5ba3c&scoped=true"
import script from "./ModifyPassword.vue?vue&type=script&lang=js"
export * from "./ModifyPassword.vue?vue&type=script&lang=js"
import style0 from "./ModifyPassword.vue?vue&type=style&index=0&id=6ed5ba3c&prod&lang=scss"
import style1 from "./ModifyPassword.vue?vue&type=style&index=1&id=6ed5ba3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed5ba3c",
  null
  
)

export default component.exports